export default __webpack_public_path__ + "static/media/vastu.a1e1f332.jpg";